import React, { useEffect, useRef, useState } from 'react'
import ttService from '@tomtom-international/web-sdk-services'
import '@tomtom-international/web-sdk-maps/dist/maps.css'
import tt from '@tomtom-international/web-sdk-maps'
import { MdStore, MdLocationOn, MdLocalShipping } from 'react-icons/md'
import { renderToStaticMarkup } from 'react-dom/server'
import ligthStreetStyle from '../assets/map-styles/ligth-street-style.json'
import ligthStreetDrivingStyle from '../assets/map-styles/ligth-street-driving.json'
import { azul, laranja, roxo, verde_escuro, vinho } from '../assets/js/colors'
import { CONFIG } from '../config'
import { getCoordinates } from './api/https/system/system.http'

const API_KEY = CONFIG[CONFIG.ENVIROMENT]['TOMTOM_API_KEY']

export const MapWithSingleMarker = ({ coordinates, setCoordinates, loadStatus }) => {
  const mapElement = useRef()
  const [, setMap] = useState({})

  useEffect(() => {
    let map = tt.map({
      key: API_KEY,
      container: mapElement.current,
      center: [coordinates.longitude, coordinates.latitude],
      zoom: 16,
      style: ligthStreetStyle,
    })
    const marker = new tt.Marker({ draggable: true }).setLngLat([
      coordinates.longitude,
      coordinates.latitude,
    ])
    changeMarkerIcon(marker, parseIconToStaticHTMLElement(MdStore({ size: 20, fill: '#FFFFFF' })))
    marker.on('dragend', updateCoordinates).addTo(map)
    map.on('load', loadStatus)
    setMap(map)
    return () => map.remove()
  }, [])

  const updateCoordinates = marker => {
    const { lng, lat } = marker.target._lngLat
    setCoordinates({ longitude: lng, latitude: lat })
  }

  return <div ref={mapElement} className="map" style={{ width: '100%', height: '100%' }}></div>
}

const changeMarkerIcon = (marker, icon) => {
  const markerElement = marker.getElement()
  markerElement.removeChild(markerElement.childNodes[1])
  markerElement.append(icon)
}

const parseIconToStaticHTMLElement = (icon, deliveries) => {
  const staticElement = renderToStaticMarkup(icon)
  const div = document.createElement('div')
  if (deliveries === undefined) deliveries = []

  const loadOrder = []
  deliveries.forEach(delivery => {
    if (delivery.load_order) loadOrder.push(delivery.load_order)
  })

  if (loadOrder.length) {
    const [max, min] = [Math.max(...loadOrder), Math.min(...loadOrder)]
    div.innerHTML =
      min === max
        ? `<p style='color: white;font-weght: bold;'>${deliveries[0].max_load_order - min + 1}</p>`
        : `<p style='color: white;font-weght: bold;'>${deliveries[0].max_load_order - max + 1}-${deliveries[0].max_load_order - min + 1}</p>`
  } else div.innerHTML = staticElement

  div.style =
    'pointer-events: auto; color: #333333; font: 12px/20px Helvetica Neue,Arial,Helvetica,sans-serif;-webkit-tap-highlight-color: rgba(0,0,0,0);cursor: grab;user-select: none;box-sizing: border-box;position: absolute;top: 0px;left: 0px;width: 30px;height: 32px;background-image: none;overflow: hidden;display: flex;align-items: center;justify-content: center;'
  return div
}

export const getFuzzySearch = query => {
  return ttService.services.fuzzySearch({ query: query, key: API_KEY })
}

export const getGeocode = async query => {
  const res = await getCoordinates(query)
  return res
}

export const MapWithMultipleLocations = ({ customers, openModal, changeLoadStatus }) => {
  const mapElement = useRef()
  const [, setMap] = useState({})

  useEffect(() => {
    if (customers.length > 0 && customers[0].id !== 0) {
      const longs = customers.map(customer => customer.longitude)
      const lats = customers.map(customer => customer.latitude)
      let map = tt.map({
        key: API_KEY,
        container: mapElement.current,
        center: [longs[0], lats[0]],
        zoom: 12,
        style: ligthStreetDrivingStyle,
      })
      customers.forEach(customer => {
        if (customer.deliveries.some(delivery => delivery.status_id === 5)) {
          if (customer.vehicles) {
            customer.vehicles.length === 1
              ? createMarker(
                  [customer.longitude, customer.latitude],
                  customer.vehicles[0].color,
                  map,
                  customer,
                  openModal,
                )
              : createMarker(
                  [customer.longitude, customer.latitude],
                  vinho,
                  map,
                  customer,
                  openModal,
                )
          }
        } else if (customer.deliveries.some(delivery => delivery.status_id === 12))
          createMarker([customer.longitude, customer.latitude], laranja, map, customer, openModal)
        else createMarker([customer.longitude, customer.latitude], azul, map, customer, openModal)
      })
      map.on('render', () => {
        changeLoadStatus(map.loaded())
      })
      setMap(map)
      return () => map.remove()
    } else {
      changeLoadStatus(true, 'withoutCustomer')
    }
  }, [customers])

  return (
    <div
      ref={mapElement}
      className="map"
      style={{ width: '100%', height: '100%', textAlign: 'center' }}
    >
      {!customers.length > 0 ? 'Não existem entregas para fazer a associação via mapa' : ''}
    </div>
  )
}

export const createMarker = (position, color, map, customer, openModal) => {
  const marker = new tt.Marker({
    color: color,
    draggable: false,
  })
  marker.setLngLat(position)

  changeMarkerIcon(
    marker,
    parseIconToStaticHTMLElement(
      customer.icon ? customer.icon : MdStore({ size: 20, fill: '#FFFFFF' }),
      customer.deliveries,
    ),
  )
  const popup = new tt.Popup({ anchor: 'top', closeOnClick: true, closeButton: false })
  popup.setText(customer.nomeFantasia)

  if (customer.vehicles !== undefined) {
    popup.setHTML(`<div>
    <div style='font-weight: bold;text-align: center;'>${customer.nomeFantasia}</div>
    ${customer.vehicles.map(vehicle => `<div style='text-align: center;'>${vehicle.vehicles_badge}</div>`).join('')}
    </div>`)
  } else
    popup.setHTML(
      `<div style='font-weight: bold;text-align: center;'>${customer.nomeFantasia}</div>`,
    )

  marker.setPopup(popup)

  const markerElement = marker.getElement()

  markerElement.addEventListener('mouseover', e => {
    if (!popup.isOpen()) marker.togglePopup()
  })

  markerElement.addEventListener('mouseleave', e => {
    if (popup.isOpen()) marker.togglePopup()
  })

  markerElement.addEventListener('click', e => {
    openModal(customer.id, markerElement.firstChild)
  })

  marker.addTo(map)
}

export const MapWithRoute = ({ customers, vehicleWaypoints, changeLoadStatus }) => {
  const mapElement = useRef()
  const [, setMap] = useState({})

  useEffect(() => {
    if (customers.length > 0 && customers[0].id !== 0 && vehicleWaypoints.length) {
      let map = tt.map({
        key: API_KEY,
        container: mapElement.current,
        center: vehicleWaypoints[0],
        zoom: 12,
        style: ligthStreetDrivingStyle,
      })
      createMarker(
        vehicleWaypoints[0],
        verde_escuro,
        map,
        { nomeFantasia: 'Início', icon: MdLocationOn({ size: 20, fill: '#FFFFFF' }) },
        () => {},
      )
      createMarker(
        vehicleWaypoints[vehicleWaypoints.length - 1],
        roxo,
        map,
        { nomeFantasia: 'Atual', icon: MdLocalShipping({ size: 20, fill: '#FFFFFF' }) },
        () => {},
      )
      customers.forEach(customer => {
        const color = customer.has_reentrega ? laranja : azul
        createMarker([customer.longitude, customer.latitude], color, map, customer, () => {})
      })

      let loaded = false
      let removed = false
      map.on('render', () => {
        if (removed) return
        if (map.loaded() && !loaded) {
          loaded = true
          ttService.services
            .calculateRoute({
              key: API_KEY,
              locations: vehicleWaypoints.map(v => v.join(',')).join(':'),
            })
            .then(response => {
              if (removed) return
              const geojson = response.toGeoJson()
              const sourceId = 'route-source'
              const layerId = 'route-layer'

              if (map.getSource(sourceId)) {
                map.getSource(sourceId).setData(geojson)
              } else {
                map.addSource(sourceId, {
                  type: 'geojson',
                  data: geojson,
                })

                map.addLayer({
                  id: layerId,
                  type: 'line',
                  source: sourceId,
                  paint: {
                    'line-color': azul,
                    'line-width': 4,
                  },
                })
              }
            })
        }
        changeLoadStatus(map.loaded())
      })
      setMap(map)
      return () => {
        removed = true
        map.remove()
      }
    } else {
      changeLoadStatus(true, 'withoutGeolocation')
    }
  }, [customers])

  return (
    <div
      ref={mapElement}
      className="map"
      style={{ width: '100%', height: '100%', textAlign: 'center' }}
    >
      {!customers.length > 0 ? 'Não existem entregas para fazer a associação via mapa' : ''}
    </div>
  )
}
